import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Card, Form, Input, Select } from "antd";
import EducatorSelector from "../../../shared/EducatorSelector";

const { Text } = Typography;
const { TextArea } = Input;

const EducatorCreateDiscussionScreen = (props: any) => {
  const {
    submitLoading,
    actions: { createDiscussion },
  } = props;

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submittable, setSubmittable] = useState(false);
  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [question, setQuestion] = useState("");
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const discussionCategories = [
    {
      label: "General",
      value: "GENERAL",
    },
    {
      label: "Module",
      value: "MODULE",
    },
    {
      label: "Lesson",
      value: "LESSON",
    },
    {
      label: "Course",
      value: "COURSE",
    },
  ];

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => {
        if (!selectedUsers.length) {
          throw Error;
        }
        setSubmittable(true);
      })
      .catch(() => setSubmittable(false));
  }, [form, values, selectedUsers]);

  const handleUserChange = (users: string[]) => {
    setSelectedUsers(users);
  };

  const onFinish = () => {
    createDiscussion({
      discussions: { category, title, assignedTo: selectedUsers, question },
      navigate,
      createdByUser: false,
    });
  };

  return (
    <>
      <div className="xl:flex">
        <div className="xl:w-1/3 md:p-4 xl:p-0">
          <div className="flex flex-col flex-wrap gap-4 max-w-[450px] xl:max-w-[250px]">
            <Text className="text-neutral-500 font-semibold text-lg">
              Create a new Discussion
            </Text>
            <Text className="text-neutral-500 font-normal text-base">
              You can start a discussion with any user, just select category,
              user,add title and your question.
            </Text>
            <Text className="text-neutral-500 font-normal text-base">
              All discussions can be monitored at Discussion Board.
            </Text>
          </div>
        </div>
        <div className="xl:w-2/3 pb-[60px]">
          <Card className="p-8 shadow-md xl:max-w-[600px] border-none">
            <div className="h-full flex flex-col justify-between">
              <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                autoComplete="off"
                size="large"
              >
                <Text className="text-neutral-600 text-sm font-semibold">
                  Select Category
                </Text>
                <Form.Item
                  name="category"
                  rules={[
                    { required: true, message: "Please select category!" },
                  ]}
                  className="mt-2"
                >
                  <Select
                    value={category}
                    onSelect={(e) => setCategory(e)}
                    placeholder="Select from the List"
                    allowClear
                    className="min-h-[50px] shadow-md rounded-lg discussion-select"
                  >
                    {discussionCategories.map((category) => (
                      <Select.Option
                        key={category.value}
                        value={category.value}
                      >
                        {category.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Text className="text-neutral-600 text-sm font-semibold">
                  Title
                </Text>
                <Form.Item
                  name="title"
                  rules={[{ required: true, message: "Please type title!" }]}
                  className="mt-2 discussion-input"
                >
                  <Input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    autoComplete="off"
                    name="title"
                    placeholder="Type title here"
                    className="shadow-md rounded-lg"
                  />
                </Form.Item>

                <Text className="text-neutral-600 text-sm font-semibold">
                  Select User / Educator
                </Text>
                <EducatorSelector
                  onSelectionChange={handleUserChange}
                  selectedOptions={selectedUsers}
                  setSelectedOptions={setSelectedUsers}
                />

                <Text className="text-neutral-600 text-sm font-semibold">
                  Add Question / Description
                </Text>
                <Form.Item
                  name="question"
                  rules={[
                    {
                      required: true,
                      message: "Please add question / description!",
                    },
                  ]}
                  className="mt-2 discussion-input"
                >
                  <TextArea
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    placeholder="Add description here"
                    autoSize={{ minRows: 6, maxRows: 10 }}
                    className="shadow-md font-light"
                  />
                </Form.Item>

                <Form.Item>
                  <div className="w-full flex justify-between gap-4">
                    <Button
                      onClick={() => navigate("/educator/discussion")}
                      className="w-full bg-white h-[50px] border border-primary-200 text-primary-600"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="w-full bg-primary-600 h-[50px]"
                      loading={submitLoading}
                      disabled={!submittable || submitLoading}
                    >
                      {!submitLoading ? "Finish" : "Loading"}
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EducatorCreateDiscussionScreen;
